import React from 'react';
import FreshBooksInstruction from './FreshBooksInstruction';
import { INTEGRATION_CONSTANTS, SOURCE_CONSTANTS } from '../constants';
import { getFreshBooksUrl, connectToFreshBooks, getLoadImportData, getFormAndTaxYearList, getFormSetting, disconnectToFreshBooks } from './FreshBooksSaga';
import { componentKey as FreshBooksComponentKey } from './FreshBooksSlice';
import { INTEGRATION_ROUTES } from '../../../constants/constants';
import XeroZohoFreshBooksSuiteCommonComponent from '../component/xerozohofreshbookssuitecommoncomponent/XeroZohoFreshBooksSuiteCommonComponent';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';
const sagaActions = {
    getServiceUrl: getFreshBooksUrl,
    connectToService: connectToFreshBooks,
    disconnectToService: disconnectToFreshBooks,
    getLoadImportData,
    getFormAndTaxYearList,
    getFormSetting,
};
export default function FreshBooks() {
    useGarbageCollector(FreshBooksComponentKey);
    const breadcrumbsItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
        { text: 'FreshBooks' }
    ];
    return (
        <XeroZohoFreshBooksSuiteCommonComponent
            sagaActions={sagaActions}
            componentKey={FreshBooksComponentKey}
            instructionsComponent={FreshBooksInstruction}
            integrationConstants={{
                URL_CODE: INTEGRATION_CONSTANTS.URL_CODE,
                URL_SCOPE: INTEGRATION_CONSTANTS.URL_SCOPE,
                URL_ERROR: INTEGRATION_CONSTANTS.URL_ERROR,
                URL_ERROR_DESCRIPTION: INTEGRATION_CONSTANTS.URL_ERROR_DESCRIPTION,
            }}
            sourceConstant={SOURCE_CONSTANTS.FRESHBOOKS_SOURCE}
            breadcrumbsItems={breadcrumbsItems}
        />
    );
}